import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ILLEGAL_INVOCATION } from 'app/shared/util/security-util';
import { TaskService } from 'services/task.service';
import { ITask } from 'models/task.model';
import { ApplicationConfigService } from './application-config.service';
import { ApiProviderService } from './api-provider.service';
import { mapAsBody } from '../app/shared/util/request-util';
import { map } from 'rxjs/operators';
import { TaskType } from '../models/enums/task-type.enum';
import {environment} from "../environments/environment";

export type EntityResponseType = HttpResponse<ITask>;
export type EntityArrayResponseType = HttpResponse<ITask[]>;

@Injectable({ providedIn: 'root' })
export class TaskExtendedService extends TaskService {
  constructor(private apiProviderService: ApiProviderService, http: HttpClient, applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override push(task: ITask): Observable<EntityResponseType> {
    return super.push(task);
  }

  pushLast(): Observable<EntityResponseType> {
    return this.http.post<ITask>(`${environment.urlApi}api/tasks/pushLast`, null, { observe: 'response' }).pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  override create(task: ITask): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override update(task: ITask): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override partialUpdate(task: ITask): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override find(id: number): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    return super.query(req);
  }

  override delete(id: number): Observable<HttpResponse<{}>> {
    throw ILLEGAL_INVOCATION;
  }

  override addTaskToCollectionIfMissing(taskCollection: ITask[], ...tasksToCheck: (ITask | null | undefined)[]): ITask[] {
    return super.addTaskToCollectionIfMissing(taskCollection, ...tasksToCheck);
  }

  protected override convertDateFromClient(task: ITask): ITask {
    return super.convertDateFromClient(task);
  }

  protected override convertDateFromServer(res: EntityResponseType): EntityResponseType {
    return super.convertDateFromServer(res);
  }

  protected override convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    return super.convertDateArrayFromServer(res);
  }

  verify(transporterId: number, taskType: TaskType, offerId: number, customerId?: number): Observable<boolean> {
    let url = this.resourceUrl + '?taskType=' + taskType + '&offerId=' + offerId;
    if (customerId) {
      url += '&customerId=' + customerId;
    }
    return this.http.get<boolean>(url, { observe: 'response' }).pipe(mapAsBody);
  }
}
